module.exports = __webpack_public_path__ + "img/macbook.a2d47ec0.png";